export const AUTH_UNKNOWN = "UNKNOWN";
export const AUTHENTICATED = "AUTHENTICATED";
export const UNAUTHENTICATED = "UNAUTHENTICATED";

export const CUSTOM_OAUTH_PARAMETERS = {
    hd: "reach.nz",
    prompt: "select_account",
};
